import React from 'react';
import { SchoolCapIcon } from './school-cap-icon';
import { TopicCardDivider, TopicCardTitle, TOPIC_CARD_ICON_2 } from './topic-card-shared';

import schoolPersonImage from './school-person.webp';

interface SchoolTopicCardProps {
  title: string;
  className?: string;
}

export const SchoolTopicCard: React.FC<SchoolTopicCardProps> = ({ title, className = '' }) => (
  <div
    className={`flex w-full min-w-0 flex-col items-center justify-center overflow-hidden rounded-xl bg-white px-2 pb-4 pt-3 sm:px-4 sm:pb-8 sm:pt-6 ${className}`}
  >
    <div className="mt-1 flex w-full flex-col items-center sm:mt-2">
      <div className="relative flex items-start justify-center">
        <div className="absolute -left-2 top-6 h-[46px] w-[76px] shrink-0 sm:top-8 sm:h-[69.625px] sm:w-[114.569px]">
          <SchoolCapIcon fill={TOPIC_CARD_ICON_2} className="h-full w-full" />
        </div>
        <img
          src={schoolPersonImage}
          alt=""
          className="relative z-10 ml-10 aspect-[38/59] w-[65px] shrink-0 object-cover object-top sm:ml-16 sm:w-[97.397px]"
        />
      </div>
      <TopicCardDivider />
    </div>
    <TopicCardTitle title={title} />
  </div>
);
